<template>
  <van-popup
    :show="show"
    position="bottom"
    :style="{ height: '80%' }"
    round
    @update:show="handleShowChange"
  >
    <div class="picker-header">
      <span class="picker-title">选择班级</span>
      <van-icon name="cross" size="20" @click="close" />
    </div>
    <van-search
      v-model="keyword"
      placeholder="搜索班级 / 班号 / 期数 / 课程 / 老师 / 校区"
      shape="round"
      @search="loadList(true)"
      @clear="loadList(true)"
    />
    <div class="picker-list">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadList"
      >
        <van-cell
          v-for="item in list"
          :key="item.scheduleId"
          is-link
          @click="handleSelect(item)"
        >
          <template #title>
            <div class="schedule-name">{{ item.scheduleName }}</div>
            <div class="schedule-course">{{ item.courseName }}</div>
          </template>
          <template #label>
            <div class="schedule-meta">
              <van-tag v-if="item.classNumber" plain size="medium">{{ dictLabel(class_number, item.classNumber) }}</van-tag>
              <van-tag v-if="item.periodsClass" plain size="medium">{{ dictLabel(periods_class, item.periodsClass) }}</van-tag>
              <van-tag v-if="item.level" plain size="medium">{{ dictLabel(class_level, item.level) }}</van-tag>
            </div>
            <div class="schedule-desc">
              <span>{{ item.teacherName || '未安排老师' }}</span>
              <span>{{ item.schoolName || '-' }}</span>
            </div>
            <div class="schedule-desc date">
              {{ item.startDate || '-' }} ~ {{ item.endDate || '-' }}
            </div>
          </template>
        </van-cell>
        <van-empty v-if="!loading && list.length === 0" description="暂无可下单班级" />
      </van-list>
    </div>
  </van-popup>
</template>

<script setup>
import { ref, watch } from 'vue'
import { getScheduleListForOrder } from '@/api/schedule'
import { useDict, selectDictLabel } from '@/utils/dict'

const { class_level, class_number, periods_class } = useDict('class_level', 'class_number', 'periods_class')

// 字典查不到时回退原始值
function dictLabel(dict, value) {
  if (value === undefined || value === null || value === '') return ''
  const label = selectDictLabel(dict, value)
  return label === '-' ? value : label
}

const props = defineProps({
  show: { type: Boolean, default: false }
})
const emit = defineEmits(['update:show', 'select'])

const keyword = ref('')
const list = ref([])
const loading = ref(false)
const finished = ref(false)
const pageNum = ref(1)
const pageSize = 20

watch(() => props.show, (val) => {
  if (val) {
    keyword.value = ''
    list.value = []
    pageNum.value = 1
    finished.value = false
    loadList(true)
  }
})

function handleShowChange(val) {
  emit('update:show', val)
}

function close() {
  emit('update:show', false)
}

async function loadList(reset = false) {
  if (reset) {
    pageNum.value = 1
    list.value = []
    finished.value = false
  }
  loading.value = true
  try {
    const res = await getScheduleListForOrder({
      pageNum: pageNum.value,
      pageSize,
      keyword: keyword.value || undefined
    })
    const rows = res?.rows || res || []
    list.value = reset ? rows : [...list.value, ...rows]
    if (rows.length < pageSize) {
      finished.value = true
    } else {
      pageNum.value++
    }
  } catch (e) {
    finished.value = true
  } finally {
    loading.value = false
  }
}

function handleSelect(item) {
  emit('select', item)
  close()
}
</script>

<style scoped>
.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ebedf0;
}
.picker-title {
  font-size: 16px;
  font-weight: 600;
}
.picker-list {
  height: calc(100% - 108px);
  overflow-y: auto;
}
.schedule-name {
  font-weight: 600;
  color: #323233;
}
.schedule-course {
  margin-top: 3px;
  font-size: 13px;
  color: #646566;
}
.schedule-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 5px;
}
.schedule-desc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}
.schedule-desc.date {
  justify-content: flex-start;
}
</style>
